import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { Typography, BoxProps } from "@material-ui/core";

import { useAccountFinancials } from "../hooks/useAccountFinancials";
import { FinancialDetail } from "./FinancialDetail";
import { formatMoneyWithSign } from "../../../utils/formatMoney";

export const PaymentDetails: React.FC<BoxProps> = ({ ...props }) => {
  const { accountNumber } = useParams();
  const { data, status } = useAccountFinancials(accountNumber!);

  const { method, schedule, activePaymentPlans, activeDebtRecoveries } =
    data?.payment || {};

  const hasActivePaymentPlans =
    activePaymentPlans && activePaymentPlans.length > 0;
  const hasActiveDebtRecovery =
    activeDebtRecoveries && activeDebtRecoveries.length > 0;
  const { type, amount, currency } = schedule || {};

  const subtitles = useMemo(() => {
    const results: string[] = [];
    if (type) {
      if (type === "Variable") {
        results.push(type);
      } else {
        const desc = type === "Seasonal" ? "Fixed seasonal" : "Fixed";
        results.push(`${desc} (${formatMoneyWithSign(currency, amount)})`);
      }
    }
    if (hasActivePaymentPlans) {
      results.push("Payment plan active");
    }
    if (hasActiveDebtRecovery) {
      results.push("Debt recovery active");
    }
    return results;
  }, [hasActivePaymentPlans, hasActiveDebtRecovery, type, amount, currency]);

  const paymentMethod = useMemo(() => {
    switch (method) {
      case "SmartPAYG":
        return "Smart PAYG";
      case "DirectDebit":
        return "Direct Debit";
      default:
        return String(method);
    }
  }, [method]);

  return (
    <FinancialDetail
      loading={status === "loading"}
      title="Payment method"
      subtitles={subtitles}
      {...props}
    >
      <Typography variant="h5" color="textPrimary" component="span">
        {paymentMethod}
      </Typography>
    </FinancialDetail>
  );
};
